<template>
  <div class="container">
    <!-- <nav-bar leftName="返回" rightName="保存" @leftClick="leftClick" @rightClick="rightClick"></nav-bar> -->
    <div class="item-container">
      <div class="menu-content">
        <switch-list :valueS="drinkOn" @change="changeValue"></switch-list>
        <menu-list name="提醒时间" :canuse="drinkOn" :subName="timeHrizon" @handleClick="selectTime"></menu-list>
        <menu-list name="时间间隔" :canuse="drinkOn" :subName="timeCountSub" @handleClick="showPicker(timeCount)"></menu-list>
      </div>
      <button class="btn-block btn-save" @click="rightClick">保存</button>
    </div>
   <setting-internet v-if="showTip" @next="nextUpdate" @now="nowUpdate"></setting-internet>
   <ttip-select v-if="showSelectTip" @cancel="cancel" @sure="sure"></ttip-select>
  </div>
</template>
<script>
import SwitchList from '../../components/SwitchList/SwitchList.vue'
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import SettingInternet from '../../components/SettingInternet/SettingInternet.vue'
import TtipSelect from '../../components/TtipSelect/TtipSelect.vue'
import {
  mapState,
  mapMutations
} from 'vuex'
import Common from '../../assets/js/common.js'
import axios from 'axios'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()
let dateSegmentData = [
  {
    is: 'cube-date-picker',
    title: '开始时间',
    min: [0, 0, 0],
    max: [23, 59, 59],
    startColumn: 'hour',
    columnCount: 2,
    format: {
      hour: 'hh点',
      minute: 'mm分'
    }
  },
  {
    is: 'cube-date-picker',
    title: '结束时间',
    min: [0, 0, 0],
    max: [23, 59, 59],
    startColumn: 'hour',
    columnCount: 2,
    format: {
      hour: 'hh点',
      minute: 'mm分'
    }
  }
]
var column = []
export default {
  components: {
    SwitchList,
    NavBar,
    MenuList,
    SettingInternet,
    TtipSelect
  },
  data () {
    return {
      timeHrizon: '',
      timeCount: [1],
      timeCountSub: '0分钟',
      showTip: false,
      drinkOn: false,
      showSelectTip: false,
      startTime: '',
      deviceId: localStorage.getItem('max_device_id'),
      selectTimes: 0,
      quit: false
    }
  },
  computed: {
    ...mapState(['drinkWarnInfo'])
  },
  mounted () {
    Common.setTitle('喝水提醒')
    this.verify()
    if (this.drinkWarnInfo) {
      const drinkWarnInfo = this.drinkWarnInfo
      this.timeHrizon = this.computedTime()
      this.drinkOn = drinkWarnInfo.drink_on
      this.timeCount = [drinkWarnInfo.interval]
      this.timeCountSub = (!drinkWarnInfo.interval) ? '' : drinkWarnInfo.interval + '分钟'
    }
    this.setCountSelect(this.computedMin())
    this.dateSegmentPicker = this.$createSegmentPicker({
      data: dateSegmentData,
      onSelect: (selectedDates, selectedVals, selectedTexts) => {
        let startHN = parseInt(selectedTexts[0][0])
        let startMN = parseInt(selectedTexts[0][1])
        let endHN = parseInt(selectedTexts[1][0])
        let endMN = parseInt(selectedTexts[1][1])
        let startH = Common.formateDoubleNumber(startHN)
        let startM = Common.formateDoubleNumber(startMN)
        let endH = Common.formateDoubleNumber(parseInt(endHN))
        let endM = Common.formateDoubleNumber(parseInt(endMN))
        this.timeHrizon = startH + ':' + startM + '-' + endH + ':' + endM
        this.addHistory()
        let Interval = (endHN * 60 + endMN) - (startHN * 60 + startMN)
        if (Interval < this.timeCount[0]) {
          this.timeCountSub = ''
          this.timeCount.splice(0, 1, 1)
        }
        this.setCountSelect(Interval)
      },
      onNext: (i, selectedDate, selectedValue, selectedText) => {
        let selectNext = Common.timestampToTime(Common.getGMTTime(selectedDate) + 60 * 1000)
        let nextMin = selectNext.split(' ')[1].split(':')
        dateSegmentData[1].min = nextMin
        if (i === 0) {
          this.dateSegmentPicker.$updateProps({
            data: dateSegmentData
          })
        }
      }
    })
  },
  destroyed () {
    this.cancelBack()
  },
  methods: {
    ...mapMutations(['DrinkWarnInfo']),
    pushHistory () {
      let state = {
        title: '',
        url: '/' + isLocal
      }
      window.history.pushState(state, state.title, state.url)
    },
    popstate () {
      if (this.showTip) {
        this.showTip = false
        this.$router.back()
      } else if (this.showSelectTip) {
        this.showSelectTip = false
        if (this.quit) {
          this.$router.back()
        } else {
          this.pushHistory()
        }
      } else {
        if (!this.quit) {
          if (this.isModify(true)) {
            this.showSelectTip = !this.showSelectTip
            this.pushHistory()
          }
        }
      }
    },
    verify () {
      var _this = this
      window.addEventListener('popstate', _this.popstate, false)
    },
    cancelBack () {
      var _this = this
      window.removeEventListener('popstate', _this.popstate)
    },
    addHistory () {
      if (this.isModify(true)) {
        if (this.selectTimes === 0) {
          this.pushHistory()
          this.selectTimes++
        }
      } else {
        if (this.selectTimes !== 0) {
          this.$router.back()
          this.selectTimes--
        }
      }
    },
    setCountSelect (count) {
      if (count >= 120) {
        column = Common.createDwArr(120)
      } else {
        column = Common.createDwArr(count)
      }
      if (this.picker) {
        this.picker.$updateProps({
          data: [column]
        })
      }
    },
    selectTime () {
      if (!this.drinkOn) return
      this.dateSegmentPicker.show()
      if (this.startTime !== '') {
        let value = this.startTime.split(':')
        let h = parseInt(value[0])
        let m = parseInt(value[1])
        let s = 0
        dateSegmentData[0].value = [h, m, s]
        this.dateSegmentPicker.$updateProps({
          data: dateSegmentData
        })
      }
    },
    computedTime () {
      if (this.drinkWarnInfo) {
        const drinkWarnInfo = this.drinkWarnInfo
        this.startTime = drinkWarnInfo.from_time
        return (!drinkWarnInfo.from_time || !drinkWarnInfo.to_time) ? '' : drinkWarnInfo.from_time + '-' + drinkWarnInfo.to_time
      }
    },
    computedMin (timeHrizon) {
      if (this.drinkWarnInfo) {
        const drinkWarnInfo = this.drinkWarnInfo
        if (!drinkWarnInfo.from_time || !drinkWarnInfo.to_time) {
          return false
        } else {
          let toTimeM = parseInt(drinkWarnInfo.to_time.split(':')[0]) * 60 + parseInt(drinkWarnInfo.to_time.split(':')[1])
          let fromTimeM = parseInt(drinkWarnInfo.from_time.split(':')[0]) * 60 + parseInt(drinkWarnInfo.from_time.split(':')[1])
          return (toTimeM - fromTimeM)
        }
      }
    },
    showPicker (selectedIndex) {
      if (!this.drinkOn || !this.timeHrizon) return
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '时间间隔',
          data: [column],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle,
          selectedIndex: [selectedIndex[0] === 1 ? 0 : (selectedIndex[0]/5) - 1]
        })
      } else {
        // let selectIndex = column.length < selectedIndex[0] ? 0 : (selectedIndex[0])
        let selectIndex = selectedIndex[0] === 1 ? 0 : (selectedIndex[0]/5 - 1)
        this.picker.$updateProps({
          data: [column],
          selectedIndex: [selectIndex === 0 ? 0 : selectIndex]
        })
      }
      this.picker.show()
    },
    selectHandle (selectedVal, selectedIndex, selectedText) {
      this.timeCount[0] = selectedVal[0]
      this.addHistory()
      this.timeCountSub = selectedVal[0] + '分钟'
    },
    rightClick () {
      if (this.isModify()) {
        this.settingWater()
      }
    },
    leftClick () {
      this.$router.back()
      /* if (this.isModify(true)) {
        this.showSelectTip = true
      } else {
        this.$router.push({path: '/Setting'})
      } */
    },
    nextUpdate () {
      // this.settingWater()
      this.$router.back()
    },
    nowUpdate () {
      // this.settingWater()
      this.quit = true
      this.$router.back()
    },
    cancel () {
      this.$router.back()
    },
    sure () {
      this.quit = true
      this.$router.back()
    },
    settingWater () {
      this.toast = this.$createToast({
        time: 0,
        txt: '保存中...',
        mask: true
      }).show()
      let toTime = this.timeHrizon.split('-')[1]
      let fromTime = this.timeHrizon.split('-')[0]
      if (isLocal === 'local') {
        axios.post('/Calendar/api/device/set/device/reminder/', {
          'device_id': this.deviceId,
          'reminder': 1,
          'drink_on': this.drinkOn,
          'to_time': toTime,
          'from_time': fromTime,
          'interval': this.timeCount[0]
        })
        .then(this.settingWaterSucc)
        .catch(this.settingWaterErr)
      } else {
        axios.post(api + '/Calendar/api/device/set/device/reminder/', {
          'device_id': this.deviceId,
          'reminder': 1,
          'drink_on': this.drinkOn,
          'to_time': toTime,
          'from_time': fromTime,
          'interval': this.timeCount[0]
        })
        .then(this.settingWaterSucc)
        .catch(this.settingWaterErr)
      }
    },
    settingWaterSucc (res) {
      this.toast.hide()
      var _res = res.data
      if (_res.result !== 0) {
        console.log(_res.result)
      } else {
        this.showTip = true
        this.DrinkWarnInfo(_res.reminder_info[0][1])
      }
    },
    settingWaterErr (error) {
      this.toast.hide()
      console.log(error)
      this.toast = this.$createToast({
        txt: '设置失败',
        type: 'txt'
      }).show()
    },
    cancelHandle () {},
    changeValue (value) {
      this.drinkOn = value
      this.addHistory()
    },
    isModify (back) {
      let drinkWarnInfo = this.drinkWarnInfo
      if (!drinkWarnInfo) return false
      if (!back) {
        if (this.timeHrizon === '') {
          this.$createToast({
            type: 'correct',
            txt: '请选择时间范围',
            time: 2000
          }).show()
          return false
        }
        if (this.timeCountSub === '') {
          this.$createToast({
            type: 'correct',
            txt: '请选择时间间隔',
            time: 2000
          }).show()
          return false
        }
      }
      if (this.timeHrizon !== this.computedTime() || parseInt(this.timeCount[0]) !== parseInt(drinkWarnInfo.interval) || this.drinkOn !== drinkWarnInfo.drink_on) {
        return true
      } else {
        if (!back) {
          this.$createToast({
            type: 'correct',
            txt: '您没有做任何修改',
            time: 2000
          }).show()
        }
        return false
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .item-container
    height 100%
    overflow auto
    position relative
    .menu-content
      padding 0 16px
      background #ffffff
      /* margin-top 16px */
</style>


// WEBPACK FOOTER //
// src/pages/DrinkWater/DrinkWater.vue